// API
export var SEARCH_HINTS_URL = 'SearchHints.ashx';
export var SEARCH_CONTENT_URL = '/api/searchcontent/getsearchcontentbypage';
export var SEARCH_RESULTS_URL = '/Shared/SearchNx/Services/SearchServiceNx.asmx/GetSearchResults';
export var ADD_FAVORITE_URL = '/api/contentlistfavorites/add';
export var REMOVE_FAVORITE_URL = 'api/contentlistfavorites/delete'; // COOKIE

export var FAVORITE_COOKIE_NAME = 'SearchNxFavorite';
export var CURRENT_PAGE_COOKIE_NAME = 'SearchNxCurrentPage'; // CONSTANT VALUES

export var LOADING_TIMER = 1000;
export var SLIDER_TRACK_COLORS = {
  BC: '#0000B4',
  PB: '#002E6D',
  TBSP: '#E25714'
};